null


// WEBPACK FOOTER //
// ../../../../../../../../../travisbrown/projects/circe-generic-extras/generic-extras/src/main/scala/io/circe/generic/extras/semiauto.scala